import TreatmentDetail from "@/pages/treatment/components/TreatmentDetail";
import SlimZeroOptions from "@/pages/treatment/slim-zero/components/SlimZeroOptions";
import { getTreatmentPage } from "@/mocks/treatmentPages";

export default function SlimZeroPage() {
  const data = getTreatmentPage("slim-zero");
  if (!data) return null;
  return <TreatmentDetail data={data} optionsSection={<SlimZeroOptions />} />;
}